import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

@NgModule({
  exports: [TranslateModule],
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class I18nModule {
  constructor(translate: TranslateService) {
    translate.addLangs(['pl']);
    const storedLang = localStorage.getItem('lang');
    const browserLang = translate.getBrowserLang();
    const defaultLang = storedLang || (browserLang?.match(/pl|ua/) ? browserLang : 'pl');

    translate.setDefaultLang('pl');
    translate.use(defaultLang);

    // Zapisuj zmianę języka automatycznie
    translate.onLangChange.subscribe(event => {
      localStorage.setItem('lang', event.lang);
    });
  }
}

export function translateLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}
